import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-610e8e30"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "relative bg-mainDark w-full h-full text-white text-lg py-6 px-4 z-[1000] top-[var(--ion-safe-area-top)]"
}
const _hoisted_2 = { class: "grid gap-4" }
const _hoisted_3 = { class: "flex justify-between items-center" }

import { ref, computed } from 'vue'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'
import { useEvents } from '@/composables/events'
import ChangeLocale from '@/components/ChangeLocale.vue'
import LogoutButton from '@/components/LogoutButton.vue'
import WebsiteLink from '@/components/WebsiteLink.vue'

// const grid = useGrid('tailwind')

export default /*#__PURE__*/_defineComponent({
  __name: 'MenuModal',
  setup(__props) {

const { t } = useI18n()
const modalOpen = ref(false)
const { modalEventBus } = useEvents()
modalEventBus.on(
	(event, payload) => { 
		if (payload?.type !== 'menu') return
		if (event === 'open') modalOpen.value = true
		else if (event === 'close') modalOpen.value = false
	}
)

const isLoggedIn = computed(() => store.getters.isLoggedIn)
const store = useStore()

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_Transition, {
    appear: "",
    name: "menu"
  }, {
    default: _withCtx(() => [
      (modalOpen.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (isLoggedIn.value)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: "/zoznam",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(modalEventBus).emit('close', { type: 'menu' })))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('order_list_title')), 1)
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(WebsiteLink, { key: 1 })),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("span", null, _toDisplayString(_unref(t)('change_language')), 1),
                _createVNode(ChangeLocale, { class: "max-w-[6rem]" })
              ]),
              _createVNode(LogoutButton)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})